import { render, staticRenderFns } from "./informationForm.vue?vue&type=template&id=d5b62836&scoped=true&"
import script from "./informationForm.vue?vue&type=script&lang=js&"
export * from "./informationForm.vue?vue&type=script&lang=js&"
import style0 from "./informationForm.vue?vue&type=style&index=0&id=d5b62836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b62836",
  null
  
)

export default component.exports